export default [
  {
    additionalAttributes: {
      city: 'Los Angeles',
      country: 'United States',
      description:
        "I'm Support, a developer focusing on building web solutions. Currently, I’m working as a Product Developer at Winker.",
      companyName: 'Winker',
      countryCode: 'US',
      socialProfiles: {
        github: 'support-dev',
        twitter: 'support_w_dev',
        facebook: 'support.dev',
        linkedin: 'support-w',
        instagram: 'support.codes',
      },
    },
    availabilityStatus: 'offline',
    email: 'support@winker.com.br',
    id: 22,
    name: 'Support Winker',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-11-11T11:53:09.299Z',
      linkContact: 'https://example.com',
      listContact: 'Follow-Up',
      textContact: 'Hi there!',
      numberContact: '42',
      checkboxContact: false,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'San Francisco',
      country: 'United States',
      description: 'Passionate about design and user experience.',
      companyName: 'Designify',
      countryCode: 'US',
      socialProfiles: {
        github: 'help-winker',
        twitter: 'help_winker',
        facebook: 'help.winker',
        linkedin: 'help-winker',
        instagram: 'help.winker',
      },
    },
    availabilityStatus: 'offline',
    email: 'help@winker.com.br',
    id: 21,
    name: 'Help Winker',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-10-05T10:12:34.567Z',
      linkContact: 'https://winker.com.br',
      listContact: 'Prospects',
      textContact: 'Looking forward to connecting!',
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Austin',
      country: 'United States',
      description: 'Avid coder and tech enthusiast.',
      companyName: 'CodeHub',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker',
        twitter: 'sup_winker',
        facebook: 'sup_winker',
        linkedin: 'sup_winker',
        instagram: 'sup_winker',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker@winker.com.br',
    id: 20,
    name: 'Sup Winker',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Let’s collaborate!',
      checkboxContact: true,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Seattle',
      country: 'United States',
      description: 'Product manager with a love for innovation.',
      companyName: 'InnovaTech',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker2',
        twitter: 'sup_winker2',
        facebook: 'sup_winker2',
        linkedin: 'sup_winker2',
        instagram: 'sup_winker2',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker2@winker.com.br',
    id: 19,
    name: 'Sup Winker2',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Let’s schedule a call.',
    },
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Chicago',
      country: 'United States',
      description: 'Marketing specialist and content creator.',
      companyName: 'Contently',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker3',
        twitter: 'sup_winker3',
        facebook: 'sup_winker3',
        linkedin: 'sup_winker3',
        instagram: 'sup_winker3',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker3@winker.com.br',
    id: 18,
    name: 'Sup Winker3',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Boston',
      country: 'United States',
      description: 'SEO expert and analytics enthusiast.',
      companyName: 'OptiSearch',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker4',
        twitter: 'sup_winker4',
        facebook: 'sup_winker4',
        linkedin: 'sup_winker4',
        instagram: 'sup_winker4',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker4@winker.com.br',
    id: 17,
    name: 'Sup Winker4',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Denver',
      country: 'United States',
      description: 'UI/UX designer with a flair for minimalist designs.',
      companyName: 'Minimal Designs',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker5',
        twitter: 'sup_winker5',
        facebook: 'sup_winker5',
        linkedin: 'sup_winker5',
        instagram: 'sup_winker5',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker5@winker.com.br',
    id: 16,
    name: 'Sup Winker5',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Miami',
      country: 'United States',
      description: 'Entrepreneur with a background in e-commerce.',
      companyName: 'Ecom Solutions',
      countryCode: 'US',
      socialProfiles: {
        github: 'sup_winker6',
        twitter: 'sup_winker6',
        facebook: 'sup_winker6',
        linkedin: 'sup_winker6',
        instagram: 'sup_winker6',
      },
    },
    availabilityStatus: 'offline',
    email: 'sup_winker6@winker.com.br',
    id: 15,
    name: 'Sup Winker6',
    phoneNumber: '+11111111111',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
];
